import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectMutation, QueryClient } from '@tanstack/angular-query-experimental';
import { AccountingPeriodService, CreateAccountingPeriodRequest, UpdateAccountingPeriodRequest } from '../../../../../../../../api';
import { QueryKey } from '../../../../../../../constants/query-key';

@Injectable()
export class AccountingPeriodCommandService {
  private readonly accountingPeriodService = inject(AccountingPeriodService);
  private readonly queryClient = inject(QueryClient);

  createMutation = injectMutation(() => ({
    mutationFn: (request: CreateAccountingPeriodRequest) =>
      lastValueFrom(this.accountingPeriodService.createAccountingPeriod(request)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.ACCOUNTING_PERIODS] });
    },
  }));

  updateMutation = injectMutation(() => ({
    mutationFn: (request: { id: number; body: UpdateAccountingPeriodRequest }) =>
      lastValueFrom(this.accountingPeriodService.updateAccountingPeriod(request.id, request.body)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.ACCOUNTING_PERIODS] });
    },
  }));
}
